import { createFileRoute, redirect } from '@tanstack/react-router';
import { permissionSetFor } from '@/lib/me';
import { resolveLandingPath } from '@/lib/navigation';
import { ensureProvisionedMe, ensureSession } from '@/lib/route-guards';

export const Route = createFileRoute('/')({
  beforeLoad: async ({ context }) => {
    const session = await ensureSession(context.queryClient);
    if (!session.data) {
      throw redirect({ to: '/login', search: { next: '/' } });
    }
    // Land on the first page the user can actually access. `ensureProvisionedMe`
    // handles the unprovisioned/blocked/expired cases (→ /no-access or /login);
    // a null landing means "provisioned but no accessible page" → /no-access.
    const me = await ensureProvisionedMe(context.queryClient, '/');
    const target = resolveLandingPath(permissionSetFor(me));
    throw redirect({ to: target ?? '/no-access' });
  },
});
